<template>
    <div class="animated fadeIn">
        <b-card>
            <div slot="header">
                Reserve Reserved Form
                <div class="card-header-actions">
                    <button v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()">
                        <i class="fa fa-save"></i> Save
                    </button>
                    <button class="btn btn-danger mr-1" @click="close()">
                        <i class="fa fa-close"></i> Close
                    </button>
                </div>
            </div>
            <b-row>
                <b-col lg="8">
                    <b-row>
                        <b-col lg="6">
                            <b-input-group>
                                <b-input-group-prepend><label>Reserve Number</label></b-input-group-prepend>
                                <b-form-input v-model="model.nomor" readonly></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col lg="6">
                            <b-input-group>
                                <b-input-group-prepend><label>Reserve Date</label></b-input-group-prepend>
                                <b-form-input v-model="model.tanggal" type="date" :max="maxIssuedDate"
                                    :state="!$v.model.tanggal.$error"></b-form-input>
                            </b-input-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col lg="6">
                            <b-input-group>
                                <b-input-group-prepend><label style="width: 160px">Reserve
                                        Store/Warehouse</label></b-input-group-prepend>
                                <b-form-select v-model="model.idStore" :plain="true" :options="Warehouse"
                                    :state="!$v.model.idStore.$error" :disabled="(issuedLines.items.length>0) && (model.idStore!='')"></b-form-select>
                            </b-input-group>
                        </b-col>
                    </b-row>
                    <b-input-group>
                        <b-input-group-prepend><label>Note/Remark</label></b-input-group-prepend>
                        <b-form-input v-model="model.uraian" :state="!$v.model.uraian.$error"
                            placeholder="Note/Remark"></b-form-input>
                    </b-input-group>

                    <b-input-group>
                        <b-input-group-prepend><label>Expected Delivery</label></b-input-group-prepend>
                        <b-form-input v-model="model.expectreceipt" type="date" disabled></b-form-input>
                    </b-input-group>

                </b-col>
                <b-col md="4">
                    <v-dim :model="model" :key="updateDimHdr"></v-dim>
                </b-col>
            </b-row>

            <b-form-row class="mb-0">
                <b-col lg="7">
                    <b-row v-if="model.sales == 0 && model.lostbroken == 0">
                        <b-col lg="5">
                            <b-input-group>
                                <b-input-group-prepend><label style="width:130px;">Requisition No.</label></b-input-group-prepend>
                                <b-form-input readonly v-model="model.requestno"
                                    :state="!$v.model.requestno.$error"></b-form-input>
                                <b-input-group-append>
                                    <b-btn text="Button" @click="lkuMrShow = true">
                                        <i class="fa fa-search"></i>
                                    </b-btn>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col>
                        <b-col lg="7">
                            <b-input-group>
                                <b-input-group-prepend><span class="p-2">Internal Budget</span></b-input-group-prepend>
                                <b-form-input v-model="model.budgetinfo" readonly v-b-tooltip.hover
                                    :title="model.budgetname"></b-form-input>
                                <b-input-group-append>
                                    <b-btn text="Button" @click="lkuBudgetShow = true">
                                        <i class="fa fa-search"></i>
                                    </b-btn>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col>
                        
                    </b-row>
                    <b-row v-if="model.sales == 1">
                        <b-col lg="5">
                            <b-input-group>
                                <b-input-group-prepend><label style="width:130px;">Requisition No.</label></b-input-group-prepend>
                                <b-form-input readonly v-model="model.requestno"
                                    :state="!$v.model.requestno.$error"></b-form-input>
                                <b-input-group-append>
                                    <b-btn text="Button" @click="lkuMrShow = true">
                                        <i class="fa fa-search"></i>
                                    </b-btn>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col>
                        <b-col lg="7">
                            <b-input-group>
                                <b-input-group-prepend><span class="p-2">Internal Budget</span></b-input-group-prepend>
                                <b-form-input v-model="model.budgetinfo" readonly v-b-tooltip.hover
                                    :title="model.budgetname"></b-form-input>
                                <b-input-group-append>
                                    <b-btn text="Button" @click="lkuBudgetShow = true">
                                        <i class="fa fa-search"></i>
                                    </b-btn>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col>
                        
                    </b-row>
                </b-col>

                <b-col cols="5" v-if="model.requestno">
                    <div style="float: right">
                        <b-pagination align="right" :total-rows="requested.total" :per-page="requested.limit"
                            v-model="requested.page"></b-pagination>
                    </div>
                    <div style="text-align: right; float: right; padding: 6px 2px 4px 4px" class="bg-warning">
                        Requested Items {{ (requested.page - 1) * requested.limit + 1 }} to
                        <span v-if="requested.page * requested.limit > requested.total">{{
                            requested.total
                        }}</span>
                        <span v-else>{{ requested.page * requested.limit }}</span>
                        of {{ requested.total }}, <span class="mr-1">limit per page :</span>
                        <input type="number" style="width: 60px" v-model="requested.limit" />
                    </div>
                </b-col>
            </b-form-row>


            <b-card no-body style="margin-top: -15px !important" v-if="model.requestno">
                <b-table class="mb-0" ref="tblRequestedItems" outlined hover small style="font-size: smaller"
                    :items="requested.items" :fields="requested.fields" :current-page="requested.page"
                    :per-page="requested.limit" show-empty>
                    <template v-slot:cell(index)="data">
                        {{ data.index + 1 }}
                    </template>


                    <template v-slot:cell(action)="data">
                        <div class="text-center" v-if="((parseFloat(data.item.qtyOstand) > 0) && (data.item.ishasserialno == 0) && (data.item.isexpireable == 0))">
                            <b-row class="justify-content-center">
                                <b-button variant="outline-success" pill size="sm"
                                    @click="issuedFIFO(data.item)" :disabled="(model.idStore=='')">
                                    F I F O
                                </b-button>
                                <b-spinner type="grow" class="text-success" v-if="(model.idStore!='')"></b-spinner>
                            </b-row>
                        </div>
                    </template>


                    <template v-slot:cell(itemname)="data">
                        {{ data.item.itemname }}
                        <span v-if="data.item.remark"> | {{ data.item.remark }}</span>
                    </template>
                    <template v-slot:cell(quantity)="data">
                        {{ data.item.quantity }} {{ data.item.invunitom }}
                    </template>
                    <template v-slot:cell(qtyOstand)="data">
                        {{ data.item.qtyOstand }}
                    </template>
                    <template v-slot:cell(qtyIssued)="data">
                        <span v-if="data.item.qtyIssued">
                            {{ data.item.qtyIssued }}
                        </span>
                    </template>

                    <template v-slot:cell(empty)="scope">
                        <h4>{{ scope.emptyText }}</h4>
                    </template>
                    <template v-slot:cell(emptyfiltered)="scope">
                        <h4>{{ scope.emptyFilteredText }}</h4>
                    </template>
                </b-table>
            </b-card>

            <h5>Reserve items</h5>
            <b-card no-body class="mb-1">
                <b-table class="mb-0" ref="tblIssuedLines" outlined striped hover small style="font-size: smaller"
                    :items="issuedLines.items" :fields="issuedLines.fields" :current-page="issuedLines.page"
                    :per-page="issuedLines.limit" show-empty>
                    <template v-slot:cell(index)="data">
                        {{ data.index + 1 }}
                    </template>
                    <template v-slot:cell(itemname)="data">
                        {{ data.item.itemname }}
                        <span v-if="data.item.remark"> | {{ data.item.remark }}</span>
                    </template>
                    <template v-slot:cell(expirDate)="data">
                        <span v-if="data.item.expirDate">{{
                            data.item.expirDate | moment("DD MMM YYYY")
                        }}</span>
                    </template>

                    <template v-slot:cell(qtyRequest)="data">
                        {{ data.item.quantity }} {{ data.item.invunitom }}
                    </template>
                    <template v-slot:cell(qtyIssued)="data">
                        {{ data.item.qtyIssued }} {{ data.item.invunitom }}
                        <!-- <b-input-group>
                            <my-number class="form-control text-right" v-model="data.item.qtyIssued"
                                :precision="0"></my-number>
                            <b-input-group-append><label class="p-1">{{
                                data.item.invunitom
                            }}</label></b-input-group-append>
                        </b-input-group> -->
                    </template>

                    <template v-slot:cell(invUnitCost)="data">
                        {{ data.item.invUnitCost | numFormat }}
                    </template>

                    <template v-slot:cell(issueValue)="data">
                        {{ data.item.issueValue | numFormat }}
                    </template>
                    <template v-slot:cell(action)="data">
                        <div class="text-center">
                            <a href="javascript:void(0)" @click="editIssuedLines(data.item, data.toggleDetails)">
                                <i class="fa fa-pencil"></i>
                            </a>
                            |
                            <a href="javascript:void(0)" class="text-danger" @click="delIssuedLines(data.index)">
                                <i class="fa fa-trash"></i>
                            </a>
                        </div>
                    </template>
                    <template v-slot:row-details="row">
                        <b-card class="row-details-form">
                            <b-row align-h="center">
                                <b-col lg="7">
                                    <b-input-group>
                                        <b-input-group-prepend><label>Item Inventory</label></b-input-group-prepend>
                                        <b-form-input readonly v-model="issuedLinesObj.iteminfo"
                                            @keyup.13.native="lkuItemShow = true"
                                            :state="!$v.issuedLinesObj.iteminfo.$error"></b-form-input>
                                        <b-input-group-append>
                                            <b-btn text="Button" @click="lkuItemShow = true">
                                                <i class="fa fa-search"></i>
                                            </b-btn>
                                        </b-input-group-append>
                                        <!-- <b-input-group-append>
                                            <span  style="font-size: smaller;color: red; padding-top: 10px;">&nbsp;  Exclude Item on Transfer Out</span>
                                        </b-input-group-append> -->
                                    </b-input-group>
                                    <b-row no-gutters>
                                        <b-col md="7">
                                            <b-input-group>
                                                <b-input-group-prepend><label>Model/Type/Series</label></b-input-group-prepend>
                                                <b-form-input readonly v-model="issuedLinesObj.typeseries"></b-form-input>
                                            </b-input-group>
                                        </b-col>
                                        <b-col md="5">
                                            <b-input-group>
                                                <b-input-group-prepend><label class="ml-2">Item Serial
                                                        Number</label></b-input-group-prepend>
                                                <b-form-input readonly v-model="issuedLinesObj.serialNum"></b-form-input>
                                            </b-input-group>
                                        </b-col>
                                    </b-row>
                                    <b-row no-gutters>
                                        <b-col md="8">
                                            <b-input-group>
                                                <b-input-group-prepend><label>Item Receipt
                                                        Date</label></b-input-group-prepend>
                                                <b-form-input readonly v-model="issuedLinesObj.recivDate"
                                                    placeholder="YYYY-MM-DD"></b-form-input>
                                                <b-form-input readonly v-model="issuedLinesObj.vendorinfo" class="ml-1"
                                                    placeholder="Supplier/Vendor"
                                                    style="width: 40% !important"></b-form-input>
                                            </b-input-group>
                                        </b-col>
                                        <b-col md="4">
                                            <b-input-group>
                                                <b-input-group-prepend><label class="ml-2">Item Expired
                                                        Date</label></b-input-group-prepend>
                                                <b-form-input readonly v-model="issuedLinesObj.expirDate"></b-form-input>
                                            </b-input-group>
                                        </b-col>
                                    </b-row>
                                    <b-form-row v-show="issuedLinesObj.qtyUndefined == 0">
                                        <b-col md="6">
                                            <b-input-group>
                                                <b-input-group-prepend><label>Quantity
                                                        Available</label></b-input-group-prepend>
                                                <b-form-input v-model="issuedLinesObj.qtyAvail" type="number" readonly
                                                    v-b-tooltip.hover :title="infoQtyRequest"></b-form-input>
                                                <b-form-input v-model="issuedLinesObj.invunitom" readonly
                                                    class="ml-1"></b-form-input>
                                            </b-input-group>
                                        </b-col>
                                        <b-col md="6" class="pt-2">
                                            <span class="text-danger">Exclude Item on Transfer Out</span>
                                        </b-col>
                                    </b-form-row>
                                </b-col>
                                <b-col lg="5">
                                    <b-input-group v-show="issuedLinesObj.qtyUndefined == 0">
                                        <b-input-group-prepend><label>Quantity Reserved</label></b-input-group-prepend>
                                        <b-form-input v-model="issuedLinesObj.qtyIssued" type="number"
                                            :state="!$v.issuedLinesObj.qtyIssued.$error" v-b-tooltip.hover
                                            :title="infoQtyRequest"></b-form-input>
                                        <b-form-input v-model="issuedLinesObj.invunitom" readonly
                                            class="ml-1"></b-form-input>
                                    </b-input-group>
                                    <b-input-group v-show="issuedLinesObj.qtyUndefined == 1">
                                        <b-input-group-prepend><label>Reserve Note</label></b-input-group-prepend>
                                        <b-form-input v-model="issuedLinesObj.remark"
                                            :state="!$v.issuedLinesObj.remark.$error"></b-form-input>
                                    </b-input-group>
                                    <b-row class="justify-content-center mt-1">
                                        <div>
                                            <b-input-group>
                                                <!-- <b-input-group-prepend><span class="p-2">Add Line after
                                                        update</span></b-input-group-prepend>
                                                <b-form-checkbox v-model="inputLineBerlanjut" :value="1"
                                                    :unchecked-value="0" class="pt-2"></b-form-checkbox> -->
                                                <b-input-group-append>
                                                    <b-button class="btn btn-success mr-1"
                                                        @click="saveIssuedLines()">Update</b-button>
                                                </b-input-group-append>
                                                <b-input-group-append>
                                                    <b-button class="btn btn-warning ml-1"
                                                        @click="cancelIssuedLines(row)">Cancel</b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </div>
                                    </b-row>
                                </b-col>
                            </b-row>
                        </b-card>
                    </template>
                    <template v-slot:cell(empty)="scope">
                        <h4>{{ scope.emptyText }}</h4>
                    </template>
                    <template v-slot:cell(emptyfiltered)="scope">
                        <h4>{{ scope.emptyFilteredText }}</h4>
                    </template>
                </b-table>
                <b-form-row>
                    <b-col cols="6">
                        <b-row>
                            <b-button size="sm" class="ml-3" @click.stop="addIssuedLines" :disabled="(!(model.idStore))">Add Reserved item</b-button>
                            <div style="padding-top: 2px">
                                Showing
                                {{ (issuedLines.page - 1) * issuedLines.limit + 1 }}
                                to
                                {{ issuedLines.page * issuedLines.limit }}
                                <strong>
                                    of
                                    {{ issuedLines.total }}
                                    Reserve Items
                                </strong>
                            </div>
                        </b-row>
                    </b-col>
                    <b-col cols="6">
                        <div style="float: right">
                            <b-pagination align="right" size="sm" :total-rows="issuedLines.total"
                                :per-page="issuedLines.limit" v-model="issuedLines.page"></b-pagination>
                        </div>
                        <div style="
                width: 400px;
                text-align: right;
                float: right;
                padding-top: 2px;
              ">
                            Reserve Items
                            {{ (issuedLines.page - 1) * issuedLines.limit + 1 }} to
                            <span v-if="issuedLines.page * issuedLines.limit > issuedLines.total">{{ issuedLines.total
                            }}</span>
                            <span v-else>{{ issuedLines.page * issuedLines.limit }}</span>
                            of {{ issuedLines.total }},
                            <span class="mr-1">limit per page :</span>
                            <input type="number" style="width: 60px" v-model="issuedLines.limit" />
                        </div>
                    </b-col>
                </b-form-row>
            </b-card>
            <b-row>
                <b-col lg="5">
                    <b-input-group v-if="model.lostbroken == 0">
                        <b-input-group-prepend><label>Received By</label></b-input-group-prepend>
                        <b-form-input v-model="model.receivby" ></b-form-input>
                    </b-input-group>
                </b-col>
                <b-col>
                    <b-row class="justify-content-center mb-2">
                        <div style="width: 450px">
                            <b-input-group>
                                <b-input-group-prepend><span class="p-2">remain on Form after
                                        save</span></b-input-group-prepend>
                                <b-form-checkbox v-model="inputBerlanjut" :value="1" :unchecked-value="0"
                                    class="pt-2"></b-form-checkbox>
                                <b-input-group-append>
                                    <button v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()">
                                        <i class="fa fa-save"></i> Save
                                    </button>
                                </b-input-group-append>
                                <b-input-group-append>
                                    <button class="btn btn-danger mr-1" @click="close()">
                                        <i class="fa fa-close"></i> Close
                                    </button>
                                </b-input-group-append>
                            </b-input-group>
                        </div>
                    </b-row>
                </b-col>
            </b-row>
        </b-card>
        <b-modal v-model="lkuItemShow" size="lg" :hide-footer="true" title="List of Available Inventory"
            :key="model.idStore" :centered="true">
            <lku-item @click="onSelectLkuItem" :idStore="model.idStore" :arrItem="model.arrItem" :key="itemchanged"
                :typeseries="issuedLinesObj.typeseries" :issuedItems="issuedLines.items"></lku-item>
        </b-modal>
        <b-modal v-model="lkuTradingShow" size="lg" :hide-footer="true" title="List of Trading Transaction"
            :centered="true">
            <lku-trading @click="onSelectLkuTrading"></lku-trading>
        </b-modal>
        <b-modal v-model="lkuMrShow" size="lg" :hide-footer="true" title="List of APPROVED Material Requesition"
            :centered="true">
            <lku-mr @click="onSelectLkuMr"></lku-mr>
        </b-modal>
        <b-modal v-model="lkuBudgetShow" size="lg" :hide-footer="true" title="List of Internal Budget Items"
            :centered="true">
            <lku-budgetinternal @click="onSelectLkuBudget"></lku-budgetinternal>
        </b-modal>
    </div>
</template>
<style lang="scss">
.input-group {
    padding-bottom: 2px;

    .input-group-prepend {
        label {
            padding-top: 5px;
            padding-right: 5px;
            width: 120px;
        }
    }
}

.form-group {
    margin-bottom: 2px;

    .input-group {
        padding-bottom: 0;
    }
}

.row-details-form {
    .input-group-prepend {
        label {
            padding-top: 5px;
            padding-right: 5px;
            width: 100px;
        }
    }

    label {
        text-align: right !important;
    }

    legend {
        text-align: right !important;
    }
}
</style>

<script>
import toastr from "mini-toastr";
import moment from "moment";
import myNumber from "../../components/my-number";
import vDim from "../lookup/dim";
import lkuBudgetinternal from "../lookup/lkuBudgetinternalline";
// import lkuItem from "../lookup/lkuItem"; ini untuk metode EVERAGE
import lkuItem from "../lookup/lkuItemReceiptLazzy";
import lkuMr from "../lookup/lkuMr";
import lkuTrading from "../lookup/lkuTrading";
import inv from "../../apis/logistic_inv_out";
import invIn from "../../apis/logistic_inv_in";
import mr from "../../apis/logistic_mr";

import invoutreserved from "../../apis/logistic_inv_out_reserved";
import trading from "../../apis/logistic_trading";
import dimension from "../../apis/dimension";
import { validationMixin } from "vuelidate";
import {
    required,
    requiredUnless,
    requiredIf,
    numeric,
    minValue, maxValue
} from "vuelidate/lib/validators";
toastr.init();

export default {
    components: { myNumber, vDim, lkuBudgetinternal, lkuItem, lkuMr, lkuTrading },
    mixins: [validationMixin],
    validations: {
        model: {
            idStore: { required },
            tanggal: { required },
            uraian: { required },
            requestno: { required },
            issueGrpkey: { required },
        },
        issuedLinesObj: {
            iteminfo: { required },
            remark: { required: requiredIf("qtyUndefined") },
            qtyIssued: {
                // numeric,
                // minValue: minValue(1),
                required: requiredUnless("qtyUndefined")
            },
            // qtyIssued: { required },
            issueValue: { required },
        },
    },
    data() {
        return {
            saveEnabled: true,
            inputBerlanjut: 1,
            inputLineBerlanjut: 1,
            horizontal: true,
            lkuBudgetShow: false,
            lkuItemShow: false,
            itemchanged: false,
            lkuMrShow: false,
            lkuTradingShow: false,
            updateDimHdr: false,
            updateDimDtl: true,
            uanguser: this.$store.state.user.matauang,
            model: {
                idStore: "",
                tanggal: "",
                uraian: "",
                requestno: "",
                expectreceipt: "",
                arrItem: [],
                issueGrpkey: 1,
                sales: 0,
                lostbroken: 0,
            },
            requested: {
                items: [],
                selected: {},
                fields: [
                    { key: "index", label: "No.", thStyle: "width:40px" },
                    {
                        key: "partnumber",
                        label: "Item Code",
                        thStyle: "width:150px",
                        sortable: true,
                        variant: "secondary",
                    },
                    {
                        key: "itemname",
                        label: "Item Name",
                        variant: "secondary",
                        sortable: true,
                    },
                    {
                        key: "typeseries",
                        label: "Type/series",
                        variant: "secondary",
                        thStyle: "width:100px",
                    },
                    {
                        key: "qtyRequest",
                        label: "Qty. Request",
                        variant: "secondary",
                        thStyle: "width:100px",
                        thClass: "text-center",
                        tdClass: "text-center",
                        sortable: true,
                    },
                    {
                        key: "qtyissued",
                        label: "Issued",
                        variant: "secondary",
                        thStyle: "width:100px",
                        thClass: "text-center",
                        tdClass: "text-center",
                        sortable: true,
                    },
                    {
                        key: "qtyOstand",
                        label: "Oustand",
                        variant: "secondary",
                        thStyle: "width:100px",
                        thClass: "text-center",
                        tdClass: "text-center",
                        sortable: true,
                    },
                    {
                        key: "action",
                        label: "Action",
                        variant: "secondary",
                        thStyle: "width:100px",
                        thClass: "text-center",
                        tdClass: "text-center",
                    },
                ],
                page: 1,
                limit: 20,
                total: 0,
            },

            issuedLines: {
                items: [],
                selected: { qtyIssued: 0 },
                fields: [
                    { key: "index", label: "No.", thStyle: "width:40px" },
                    {
                        key: "partnumber",
                        label: "Item Code",
                        thStyle: "width:150px",
                    },
                    {
                        key: "itemname",
                        label: "Item Name",
                    },
                    {
                        key: "typeseries",
                        label: "Type/series",
                    },
                    {
                        key: "serialNum",
                        label: "Serial Number",
                        sortable: true,
                    },
                    // {
                    //     key: "qtyRequest",
                    //     label: "Qty. Request",
                    //     thStyle: "width:120px",
                    //     thClass: "text-center",
                    //     tdClass: "text-center",
                    // },
                    {
                        key: "qtyIssued",
                        label: "Qty. Reserved",
                        thStyle: "width:150px",
                        thClass: "text-center",
                        tdClass: "text-center",
                    },
                    {
                        key: "action",
                        label: "Action",
                        thStyle: "width:40px",
                        thClass: "text-center",
                    },
                ],
                page: 1,
                limit: 20,
                total: 0,
            },
            issuedLinesObj: {
                iteminfo: "",
                itemno: "",
                description: "",
                qtyIssued: 0,
                qtyIssuedB4: 0,
                issueValue: 0,
                invunitom: "",
                qtyUndefined: 0,
                remark: "",
                typeseries: "",
                // =========
                itemReciKey: '',
                invUnitCost: 0,
                reqdtlkey: '',
                reqdtlQty: 0,

            },

            infoQtyRequest: "",
            issuedGroups: [],
            Warehouse: [],
            windowClose: false
        };
    },
    computed: {
        dimension() {
            return this.$store.state.dimension;
        },
        invalidIssuedLines() {
            this.$v.issuedLinesObj.$touch();
            return this.$v.issuedLinesObj.$invalid;
        },
        invalidModel() {
            this.$v.model.$touch();
            return this.$v.model.$invalid;
        },
        qtyIssued() {
            return this.issuedLinesObj.qtyIssued;
        },
        qtyUndefined() {
            if (this.issuedLinesObj.qtyUndefined == 1) {
                return true;
            } else {
                return false;
            }
        },
        maxIssuedDate() {
            return moment(new Date()).format("YYYY-MM-DD");
        }
    },
    watch: {
        qtyIssued: function (newval) {
            setTimeout(() => {
                this.calcAmount();
            }, 100);
        },
        issuedgroup: function (newVal) {
            const group = this.issuedGroups.find((x) => x.value === newVal);
            if (group) {
                this.model.sales = group.sales;
                this.model.lostbroken = group.lostbroken;
                this.dimension.forEach((dim) => {
                    if (group[dim.value]) {
                        this.model[dim.value] = group[dim.value];
                        this.model[`${dim.value}Txt`] = group[`${dim.value}Txt`];
                        this.model[`${dim.value}Info`] = group[`${dim.value}Info`];
                        // this.model[`${dim.value}Info`] = group[dim.value] + ' | '+ group[`${dim.value}Txt`];
                    }
                });
            }
        },
    },
    created: async function () {
        const [a, b] = await Promise.all([inv.issuegroup(), inv.store()]);
        this.model.tanggal = moment().format("YYYY-MM-DD");
        this.issuedGroups = a;
        this.Warehouse = b;

        const objParam = {};
        const keysNumber = ['requestkey', 'invIssueKey'];
        keysNumber.forEach(key => {
            if (this.$route.params[key]) objParam[key] = this.$route.params[key]
            else if (this.$route.query[key]) {
                objParam[key] = this.$route.query[key]
                this.windowClose = true;
            }
        });

        if (objParam.requestkey) {
            toastr.info("Loading Request Detail, please wait");
            try {
                const data = await mr.detail(objParam);
                const row = data[0][0];
                if (row.isreject == 1) row.send2wf = 0;
                if (row.send2wf == 1) {
                    this.saveEnabled = true;
                    // if (row.isreviewed == 1) {
                    //     this.saveEnabled = true;
                    // } else {
                    //     this.saveEnabled = false;
                    // }
                }
                row.requestdate = row.requestdate
                    ? moment(row.requestdate).format("YYYY-MM-DD")
                    : "";
                row.expectreceipt = row.expectreceipt
                    ? moment(row.expectreceipt).format("YYYY-MM-DD")
                    : "";
                for (var key in row) {
                    this.model[key] = row[key];
                }


                this.model.uraian = `Inventory Reserved for ${row.requestno} - No Surat : ${(row.remark).replace('Material Request for','').trim()}`;

                this.model.requisitionInfo = `${row.channelPartnerName} | ${row.Dim2Txt}`;

                data[1].map((dt) => {
                    dt.iteminfo = `${dt.partnumber} | ${dt.itemname}`;
                    dt.qtyRequest = dt.quantity
                    dt.qtyissuedB4 = dt.qtyissued
                });

                this.requested.items = data[1];

                this.model.arrItem = [];
                this.model.arrItem = this.requested.items.reduce((newArr = [], item, idx) => {
                    newArr.push(item.itemno);
                    return newArr;
                }, []);

                // this.issuedLines.items = data[1].map((dt) => {
                //     dt.qtyIssued = 0
                //     return dt;
                // });

                // if (this.issuedGroups.length == 1) {
                //     this.model.issueGrpkey = this.issuedGroups[0].value;
                // }
                if (this.Warehouse.length == 1) {
                    this.model.idStore = this.Warehouse[0].value;
                }

                // this.tanggalBerubah();
                this.updateDimHdr = !this.updateDimHdr;
                this.inputBerlanjut = 0;
                toastr.clear;
            } catch (error) {
                console.log("error : ", error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");
            }
        } else if (objParam.invIssueKey) {
            toastr.info("Loading Request Detail, please wait");
            try {
                const [data] = await Promise.all([
                    // inv.issuegroup(),
                    // inv.store(),
                    invoutreserved.detail(objParam),
                ]);
                // this.issuedGroups = a;
                // this.Warehouse = b;
                const row = data[0];
                // this.saveEnabled=(row.send2wf === 0);
                row.tanggal = row.tanggal
                    ? moment(row.tanggal).format("YYYY-MM-DD")
                    : "";
                for (var key in row) {
                    this.model[key] = row[key];
                }

                this.issuedLines.items = data[1].map(dt => {
                    return dt;
                })
                this.issuedLines.total = this.issuedLines.items.length;
                if (this.model.requestkey){
                    this.requested.items = data[3] || [];
                    this.requested.total = this.requested.items.length;
                    this.requested.items.forEach((req) => {
                        req.qtyissuedB4 = req.qtyissued;
                    });
                }
                this.calcTotalDtlIssued();
                // this.tanggalBerubah();
                this.updateDimHdr = !this.updateDimHdr;
                this.$forceUpdate();
                toastr.clear;
            } catch (error) {
                console.log("error : ", error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");
            }
        }
    },
    methods: {
        onSelectLkuBudget: async function (_selected) {
            try {
                this.model.remark = _selected.uraian;
                this.model.budgetname = _selected.uraian;
                this.model.budgetnumber = _selected.nomorintern;
                this.model.jccostname = _selected.jccostname;
                this.model.budgetinfo =
                    _selected.nomorintern + " | " + _selected.jccostname;
                this.model.nomorproduksi = _selected.noprodintern;
                this.model.ibudgdtkey = _selected.ibudgdtkey;
                this.model.ibudghdkey = _selected.ibudghdkey;
                this.model.pjxbudgkey = _selected.pjxbudgkey;
                this.model.pjxkey = _selected.pjxhdrkey;
                this.model.DimTableKey = _selected.DimTableKey;
                this.budgetbalance = _selected.ibbudgetamt - _selected.requestamt;

                this.model.expectreceipt = _selected.requstart
                    ? moment(_selected.requstart).format("YYYY-MM-DD")
                    : "";
                this.dimension.forEach((dim) => {
                    if (_selected[dim.value]) {
                        this.model[dim.value] = _selected[dim.value];
                        this.model[`${dim.value}Txt`] = _selected[`${dim.value}Txt`];
                        this.model[`${dim.value}Info`] =
                            _selected[dim.value] + " | " + _selected[`${dim.value}Txt`];
                    }
                    if (dim.RelatedObj == "internalbudget") {
                        this.model[`${dim.value}`] = _selected.nomorintern;
                        this.model[`${dim.value}Txt`] =
                            _selected.uraian + " # " + _selected.noprodintern;
                        this.model[`${dim.value}Info`] =
                            _selected.nomorintern +
                            " | " +
                            _selected.uraian +
                            " # " +
                            _selected.noprodintern;
                    }
                });
                this.updateDimHdr = !this.updateDimHdr;

                this.lkuBudgetShow = false;
            } catch (error) {
                console.log("error : ", error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");
            }
        },
        closeIssuedLines: function () {
            const opened = this.issuedLines.items.find((r) => r._showDetails == true);
            if (opened) opened._showDetails = false;
        },
        addIssuedLines: function () {
            this.closeIssuedLines();
            const obj = { _showDetails: true };
            this.issuedLines.selected = obj;
            for (var key in this.issuedLinesObj) {
                this.issuedLinesObj[key] = "";
            }
            this.issuedLinesObj.invunitom = "EACH";
            this.issuedLinesObj.qtyIssued = 0;
            this.issuedLinesObj.qtyUndefined = 0;
            this.infoQtyRequest = "";
            this.updateDimHdr2Dtl(this.issuedLinesObj);
            this.issuedLines.items.push(obj);
            this.issuedLines.total = this.issuedLines.items.length;
            setTimeout(() => {
                const bfore = this.issuedLines.page;
                const after = Math.ceil(
                    this.issuedLines.total / this.issuedLines.limit
                );
                if (bfore != after) {
                    this.issuedLines.page = after;
                    toastr.info(
                        `Move to page ${after} of total  ${this.issuedLines.total} items`,
                        "Line/Detail",
                        10000
                    );
                }
            }, 100);
            this.inputLineBerlanjut = 1;
        },
        editIssuedLines: function (obj, callback) {
            this.closeIssuedLines();
            this.issuedLines.selected = obj;
            for (var key in this.issuedLinesObj) {
                this.issuedLinesObj[key] = "";
            }
            for (var key in obj) {
                if(obj[key]){
                    this.issuedLinesObj[key] = obj[key];
                }
            }
            this.issuedLinesObj.qtyIssuedB4 = this.issuedLinesObj.qtyIssued
            this.infoQtyRequest = "";
            if((obj.partnumber||'')!='' && (obj.itemname || '')!=''){
                this.issuedLinesObj.iteminfo = `${obj.partnumber||''} | ${obj.itemname || ''}`;
            }
            this.issuedLinesObj.typeseries = obj.typeseries || '';
            this.dimension.forEach((dim) => {
                if (obj[dim.value]) {
                    this.issuedLinesObj[dim.value] = obj[dim.value];
                    this.issuedLinesObj[`${dim.value}Txt`] = obj[`${dim.value}Txt`];
                    this.issuedLinesObj[`${dim.value}Info`] =
                        obj[dim.value] + " | " + obj[`${dim.value}Txt`];
                }
            });
            this.inputLineBerlanjut = 0;
            callback();
        },
        delIssuedLines: function (index) {
            if (index > -1) {
                // this.issuedLines.items.splice(index, 1);
                const posisi = (this.issuedLines.page - 1) * this.issuedLines.limit;
                const deleted = this.issuedLines.items[posisi + index];
                if (deleted) {
                    this.updateQtyIssued(
                        deleted,
                        -1 * parseFloat(deleted.qtyissued)
                    );
                }
                this.issuedLines.items.splice(posisi + index, 1);
            }
            this.issuedLines.total = this.issuedLines.items.length;
            this.calcTotalDtlIssued();
        },
        updateQtyIssued: function (obj, qty) {
            const{itemno,typeseries} = obj;
            let ada = this.requested.items.find((r) => r.itemno == itemno);
            if((typeseries||'')!=''){
                ada = this.requested.items.find((r) => (r.itemno == itemno && r.typeseries == typeseries));
            }
            if (ada) {
                ada.qtyissued = ada.qtyissuedB4 + parseFloat(this.issuedLinesObj.qtyIssued);
                ada.qtyOstand = ada.qtyRequest - ada.qtyissued
            }
            return ada;
        },
        cancelIssuedLines: function(row){
            const detail = this.issuedLines.items[row.index];
            if(!detail.itemReciKey){
                this.delIssuedLines(row.index)
            }

            row.toggleDetails();
            this.calcTotalDtlIssued();
        },
        saveIssuedLines: async function (callback) {
            this.calcAmount();
            if (this.invalidIssuedLines) {
                console.log("validation : ", this.$v.issuedLinesObj);
                console.log("model obj : ", this.issuedLinesObj);
                toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
            } else {
                if (this.issuedLinesObj.qtyIssued > this.issuedLinesObj.qtyAvail) {
                    toastr.error("QTY Reserved Melebihi Stock", "ERROR MESSAGE");
                    return;
                }
                let datadim = this.issuedLinesObj;
                datadim.TableName = "inventory_issued_line";
                try {
                    //     const dimValResult = await dimension.validate(datadim);
                    //     if (dimValResult.success) {
                    const totalBefore = this.issuedLines.items.reduce((a, b) => {
                        if (b.itemno == this.issuedLinesObj.itemno)
                            a += parseFloat(b.qtyIssued);
                        return a;
                    }, 0);

                    // this.dimension.forEach((dim) => {
                    //     if (datadim[dim.value]) {
                    //         this.issuedLines.selected[dim.value] = datadim[dim.value];
                    //         this.issuedLines.selected[`${dim.value}Txt`] = datadim[`${dim.value}Txt`];
                    //     }
                    // });
                    const totalAfter = this.issuedLines.items.reduce((a, b) => {
                        if (b.itemno == this.issuedLinesObj.itemno)
                            a += parseFloat(b.qtyIssued);
                        return a;
                    }, 0);
                    const ada = this.updateQtyIssued(
                        this.issuedLinesObj,
                        totalAfter - totalBefore
                    );

                    if (ada) {
                        if (ada.quantity - ada.qtyissued < 0) {
                            // this.issuedLines.selected._showDetails = true;
                            // if (callback) callback();
                            // this.issuedLines.selected = {};
                            // this.issuedLines.items = [];
                            // clonedIssuedItems.forEach((item) => {
                            //     this.issuedLines.items.push(item);
                            // });
                            // return;
                            console.log('this.issuedLinesObj.qtyIssuedB4',this.issuedLinesObj.qtyIssuedB4)
                            this.issuedLinesObj.qtyIssued = parseInt(this.issuedLinesObj.qtyIssuedB4);
                            console.log('this.issuedLinesObj.qtyIssued',this.issuedLinesObj.qtyIssued)
                            throw new Error('Qty Issued exceed the qty requested')
                        }

                    }

                    for (var key in this.issuedLinesObj) {
                        this.issuedLines.selected[key] = this.issuedLinesObj[key];
                    }
                    this.issuedLines.selected.issueValue =
                        this.issuedLines.selected.invUnitCost *
                        this.issuedLines.selected.qtyIssued;


                    this.updateDimDtl2Hdr(datadim);
                    this.calcTotalDtlIssued();
                    this.issuedLines.selected._showDetails = false;
                    if (callback) callback();
                    if (this.inputLineBerlanjut == 1) {
                        this.addIssuedLines();
                        this.$v.issuedLinesObj.$reset();
                    }

                    // } else {
                    //     var msg = dimValResult.message;
                    //     if (callback) callback(new Error(msg));
                    //     else {
                    //         toastr.error(msg, "ERROR MESSAGE",10000);
                    //     }
                    // }
                } catch (error) {
                    console.log("error : ", error);
                    if (error.message) {
                        toastr.error(error.message, "ERROR MESSAGE", 10000);
                    } else {
                        toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
                    }
                }
            }
        },
        issuedFIFO: async function (obj) {
            toastr.info(`getting Available Stock for "${obj.itemname}"`);
            const objParam = {...obj, idStore:this.model.idStore}
            invIn.getAvailItem(objParam).then(result => {
                if (result.inventories.length==0) {
                    toastr.error(`No Available Stock for "${result.itemname}"`, "INFO MESSAGE", 10000);
                    return;
                }
                toastr.info(`Process FIFO "${result.itemname}"`);
                const itemreq = this.requested.items.find(x => x.reqdtlkey == result.reqdtlkey);
                for (let index = 0; index < result.inventories.length; index++) {
                    const _selected = result.inventories[index];
                    const issuedLinesObj={}
                    this.lkuItemShow = false;
                    let keys = [
                        'partnumber', 'itemname', 'serialNum',
                        'itemReciKey',
                        'invUnitCost',
                        'reqdtlkey',
                        'reqdtlQty',
                        'typeseries', 'serialNum', 'recivDate',
                        'vendorinfo', 'expirDate', 'qtyAvail', 'invunitom', 'itemno', 'qtyRequest'
                    ];

                    for (const key in _selected) {
                        if (keys.indexOf(key) >= 0 && _selected[key]) {
                            issuedLinesObj[key] = _selected[key];
                        }
                    }
                    issuedLinesObj.invunitom = _selected.invunitom || itemreq.invunitom
                    issuedLinesObj.qtyIssued = 0;
                    issuedLinesObj.iteminfo =
                        _selected.partnumber.trim() + " | " + _selected.itemname.trim();
                    issuedLinesObj.typeseries = _selected.typeseries;
                    issuedLinesObj.invUnitCost = _selected.invUnitCost;
                    issuedLinesObj.issueValue =
                        issuedLinesObj.invUnitCost * issuedLinesObj.qtyIssued;
                    issuedLinesObj.expirDate = _selected.expirDate
                        ? moment(_selected.expirDate).format("YYYY-MM-DD")
                        : "";
                    issuedLinesObj.recivDate = _selected.recivDate
                        ? moment(_selected.recivDate).format("YYYY-MM-DD")
                        : "";
                    if (itemreq) {
                        if (_selected.qtyAvail < itemreq.qtyOstand) {
                            const qtyIssued = parseFloat(_selected.qtyAvail);                                                    
                            itemreq.qtyissued = parseFloat(itemreq.qtyissued || 0) + qtyIssued
                            issuedLinesObj.qtyIssued = qtyIssued;
                            issuedLinesObj.qtyIssuedB4 = issuedLinesObj.qtyIssued;
                            itemreq.qtyOstand= parseFloat(itemreq.qtyOstand)-qtyIssued;
                            this.issuedLines.items.push(issuedLinesObj);

                        } else {
                            const qtyIssued = parseFloat(itemreq.qtyOstand);                                                    
                            itemreq.qtyissued = parseFloat(itemreq.qtyissued || 0) + qtyIssued;
                            issuedLinesObj.qtyIssued = qtyIssued;
                            issuedLinesObj.qtyIssuedB4 = issuedLinesObj.qtyIssued;
                            itemreq.qtyOstand=0
                            this.issuedLines.items.push(issuedLinesObj);
                            break;
                        }
                    } else {
                        break;
                    }
                }
                if (itemreq) {
                        // this.infoQtyRequest = `QTY REQUEST: ${itemreq.quantity} ${itemreq.invunitom || ""
                        //     }`.trim();
                    if (itemreq.qtyOstand==0) {
                        toastr.info(`${itemreq.itemname} QTY REQUEST: ${itemreq.quantity} ${itemreq.invunitom || ""}, QTY ISSUED: ${itemreq.qtyissued} ${itemreq.invunitom || ""}, COMPLETED !!! `);
                    } else {
                        toastr.info(`${itemreq.itemname} QTY REQUEST: ${itemreq.quantity} ${itemreq.invunitom || ""}, QTY ISSUED: ${itemreq.qtyissued} ${itemreq.invunitom || ""}, OUTSTANDING: ${itemreq.qtyOstand} ${itemreq.invunitom || ""}`);
                    }
                }
                this.issuedLines.total = this.issuedLines.items.length;
                this.issuedLines.items.sort(
                        function(a, b) {          
                            if ( a.partnumber < b.partnumber ){
                                return -1;
                            }
                            if ( a.partnumber > b.partnumber ){
                                return 1;
                            }
                            return 0;                        
                        });
            })
            .catch(err => {
                console.log('issuedFIFO -> ', err);
            });
        },
        save: async function () {
            if (!this.saveEnabled) {
                toastr.error("View mode cannot be Saved");
                return;
            }
            this.saveEnabled = false;
            if (this.invalidModel) {
                console.log("validation : ", this.$v.model);
                console.log("model obj : ", this.model);
                toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
                this.saveEnabled = true;
            } else {
                try {
                    const opened = this.issuedLines.items.find((r) => r._showDetails == true);
                    if(opened){
                        throw new Error('There are Issued Item Detail Open,please UPDATE or CANCEL')
                    }

                    this.model.TableName = "inventory_issued";
                    const dimValResult = await dimension.validate(this.model);
                    if (dimValResult.success) {
                        // this.model.DimTableKey = diisi dari PR/SR;
                        this.model.issuedkey = this.model.issuedkey || "";
                        this.model.nomor = this.model.nomor || "";
                        const row = {};
                        for (var key in this.model) {
                            row[key] = this.model[key];
                        }
                        row.tanggal = moment(row.tanggal).format("YYYY-MM-DD");
                        let lineno = 1;
                        row.lines = this.issuedLines.items.reduce((newArr, item) => {
                            if ((item.itemno || "") != "" && item.qtyIssued != 0) {
                                item.lineno = lineno;
                                newArr.push(item);
                                lineno += 1;
                            }
                            return newArr;
                        }, []);
                        if (row.lines.length > 0) {
                            const hasil = await invoutreserved.save(row);
                            toastr.success(
                                `Success, Trx.Number ${hasil.nomor}`,
                                "Save Inventory Reserve",
                                10000
                            );

                            if (this.inputBerlanjut == 0) {
                                this.close();
                            } else {
                                this.saveEnabled = true;
                                const tanggal = this.model.tanggal;
                                for (var key in this.model) {
                                    this.model[key] = "";
                                }
                                this.model.tanggal = tanggal;
                                this.issuedLines.items = [];
                                this.issuedLines.total = this.issuedLines.items.length;
                                this.calcTotalDtlIssued();
                                this.$v.model.$reset();
                            }
                        } else {
                            toastr.error(
                                "Please fill at least 1(one) Inventory Reserve Detail",
                                "ERROR MESSAGE"
                            );
                            this.saveEnabled = true;
                        }
                    } else {
                        var msg = dimValResult.message || "Dimension validation error";
                        toastr.error(msg, "ERROR MESSAGE");
                        this.saveEnabled = true;
                    }
                } catch (error) {
                    console.log("error : ", error);
                    if (error.sql) {
                        toastr.error(error.sql, "ERROR MESSAGE", 10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
                    } else if (error.message) {
                        toastr.error(error.message, "ERROR MESSAGE", 10000);
                    } else {
                        toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
                    }
                    this.saveEnabled = true;
                }
            }
        },
        onSelectLkuItem(_selected) {
            try {
                if (_selected.qtyAvail == 0 || _selected.qtyAvail < 0) {
                    toastr.info('Item Not in Available Stock', "INFO MESSAGE", 10000);
                    return;
                }

                let adaRequest = this.requested.items.find(x => x.itemno == _selected.itemno);
                if((_selected.typeseries||'')!=''){
                    adaRequest =this.requested.items.find(x => (x.itemno == _selected.itemno && x.typeseries == _selected.typeseries));
                } 
                if (adaRequest) {
                    if (adaRequest.qtyOstand == 0 || adaRequest.qtyOstand < 0) {
                        toastr.info('Reserved untuk item ini sudah completed', "INFO MESSAGE", 10000);
                        return;
                    }
                }

                this.lkuItemShow = false;
                let keys = [
                    'partnumber', 'itemname', 'serialNum',
                    'itemReciKey',
                    'invUnitCost',
                    'reqdtlkey',
                    'reqdtlQty',
                    'typeseries', 'serialNum', 'recivDate',
                    'vendorinfo', 'expirDate', 'qtyAvail', 'invunitom', 'itemno', 'qtyRequest'
                ];

                for (const key in _selected) {
                    if (keys.indexOf(key) >= 0 && _selected[key]) {
                        this.issuedLinesObj[key] = _selected[key];
                    }
                }
                this.issuedLinesObj.qtyIssued = 0;
                this.issuedLinesObj.iteminfo =
                    _selected.partnumber.trim() + " | " + _selected.itemname.trim();
                this.issuedLinesObj.typeseries = _selected.typeseries;
                this.issuedLinesObj.invunitom = _selected.invunitom;
                this.issuedLinesObj.invUnitCost = _selected.invUnitCost;
                this.issuedLinesObj.issueValue =
                    this.issuedLinesObj.invUnitCost * this.issuedLinesObj.qtyIssued;
                this.issuedLinesObj.expirDate = _selected.expirDate
                    ? moment(_selected.expirDate).format("YYYY-MM-DD")
                    : "";
                this.issuedLinesObj.recivDate = _selected.recivDate
                    ? moment(_selected.recivDate).format("YYYY-MM-DD")
                    : "";
                const itemreq = this.requested.items.find(
                    (i) => i.itemno == _selected.itemno
                );
                if (itemreq) {
                    // this.issuedLinesObj.qtyrequest = itemreq.quantity;
                    // this.issuedLinesObj.uomrequest = itemreq.invunitom;
                    this.infoQtyRequest = `QTY REQUEST: ${itemreq.quantity} ${itemreq.invunitom || ""
                        }`.trim();
                    this.issuedLinesObj.qtyIssued =
                        _selected.qtyAvail > itemreq.quantity
                            ? itemreq.quantity
                            : _selected.qtyAvail;
                    this.issuedLinesObj.qtyIssuedB4 = this.issuedLinesObj.qtyIssued;
                    console.log('this.issuedLinesObj.qtyIssuedB4',this.issuedLinesObj.qtyIssuedB4)

                }
                this.issuedLines.total = this.issuedLines.items.length;
                this.issuedLines.items.sort(
                        function(a, b) {          
                            if ( a.partnumber < b.partnumber ){
                                return -1;
                            }
                            if ( a.partnumber > b.partnumber ){
                                return 1;
                            }
                            return 0;                        
                        });

            } catch (error) {
                toastr.error(error, "ERROR MESSAGE", 10000);

            }

        },
        async onSelectLkuMr(_selected) {
            this.lkuMrShow = false;
            this.model.requestno = _selected.requestno;
            this.model.requestkey = _selected.requestkey;
            this.model.uraian = _selected.remark;
            this.model.recivby = _selected.createby;
            this.model.reqdtlkey = _selected.reqdtlkey;
            this.model.jccostname = _selected.jccostname;
            this.model.budgetinfo =
                _selected.nomorintern + " | " + _selected.jccostname;
            this.model.nomorproduksi = _selected.noprodintern;
            this.model.ibudgdtkey = _selected.ibudgdtkey;
            this.model.ibudghdkey = _selected.ibudghdkey;
            this.model.pjxbudgkey = _selected.pjxbudgkey;
            this.model.pjxkey = _selected.pjxhdrkey;

            this.model.channelPartnerName = _selected.channelPartnerName;
            this.model.Dim2Txt = _selected.Dim2Txt;
            this.model.expectreceipt = moment(_selected.expectreceipt).format("YYYY-MM-DD");
            this.model.requisitionInfo = `${_selected.channelPartnerName} | ${_selected.Dim2Txt}`;

            const data = await mr.detail(_selected);
            const row = data[0][0];
            // if (row) {
            for (const key in row) {
                if (row[key]) {
                    this.model[key] = row[key];
                }
            }
            // isi Dimension Header Ap dengan Dimension Header PO ?
            this.model.DimTableKey = row.DimTableKey;
            this.updateDimDtl2Hdr(row);
            // this.updateDimHdr = !this.updateDimHdr;

            // untuk metode FIFO/LIFO maka detail ini hanya dipakai untuk memfilter available inventory in
            // knex select('*').from('inventory_receipt').whereIn('itemno', requested.items);
            const lines = data[1];
            this.issuedLines.items = [];
            this.model.arrItem = [];
            this.model.arrItem = lines.reduce((newArr = [], item, idx) => {
                // toastr.info(`Item Requested#${idx+1}: ${item.itemname}  | Qty:${item.quantity.toLocaleString(undefined, { maximumFractionDigits: 2 })} ${item.invunitom}`)
                newArr.push(item.itemno);
                return newArr;
            }, []);
            // console.log('Material Requested : ', this.model.arrItem);
            this.requested.items = lines;
            this.requested.total = lines.length;
            this.requested.items.forEach((req) => {
                req.qtyissuedB4 = req.qtyissued;
            });

            this.issuedLines.items = lines.map((dt) => {
                dt.qtyIssued = dt.quantity;
                return dt;
            });

            this.itemchanged = !this.itemchanged;
        },
        async onSelectLkuTrading(_selected) {
            this.model.requestno = _selected.nomor;
            this.model.requestkey = _selected.tradingKey;
            this.model.uraian =
                "Trading to " +
                _selected.pembeli +
                (_selected.uraian ? " | " + _selected.uraian : "");
            this.model.recivby = _selected.pembeli;

            const data = await trading.detail({ tradingKey: _selected.tradingKey });

            const row = data[0][0];
            for (const key in row) {
                if (row[key]) {
                    this.model[key] = row[key];
                }
            }
            // isi Dimension Header Ap dengan Dimension Header PO ?
            this.model.DimTableKey = row.DimTableKey;
            this.updateDimDtl2Hdr(row);

            const lines = data[1];
            this.issuedLines.items = [];
            this.model.arrItem = [];
            // untuk metode FIFO/LIFO maka detail ini hanya dipakai untuk memfilter available inventory in
            this.model.arrItem = lines.reduce((newArr = [], item, idx) => {
                newArr.push(item.itemno);
                return newArr;
            }, []);
            // console.log('Material Requested : ', this.model.arrItem);
            this.requested.items = lines;
            this.requested.total = lines.length;
            this.itemchanged = !this.itemchanged;

            // Untuk Metode AVERAGE maka detail langsung diisi ke IssuedLines
            for (let i = 0; i < lines.length; i += 1) {
                const newLine = {};
                for (let key in lines[i]) {
                    newLine[key] = lines[i][key];
                }
                newLine.lineno = i + 1;
                if (lines[i].qtyTrading > lines[i].qtyAvail) {
                    newLine.qtyIssued = lines[i].qtyAvail;
                    newLine.remark = "QTY Kurang";
                } else {
                    newLine.qtyIssued = lines[i].qtyTrading;
                }
                this.issuedLines.items.push(newLine);
                this.model.arrItem.push(lines[i].itemno);
            }

            this.lkuTradingShow = false;
        },
        updateDimDtl2Hdr: function (dimDtl) {
            var dimHdr = this.model;
            this.dimension.forEach((dim) => {
                if (dimDtl[dim.value] && !dimHdr[dim.value]) {
                    dimHdr[dim.value] = dimDtl[dim.value];
                    dimHdr[`${dim.value}Txt`] = dimDtl[`${dim.value}Txt`];
                    dimHdr[`${dim.value}Info`] = dimDtl[`${dim.value}Info`];
                }
            });
            this.updateDimHdr = !this.updateDimHdr;
        },
        updateDimHdr2Dtl: function (dimDtl) {
            var dimHdr = this.model;
            dimDtl = dimDtl || this.issuedLinesObj;
            this.dimension.forEach((dim) => {
                if (dimHdr[dim.value] && !dimDtl[dim.value]) {
                    dimDtl[dim.value] = dimHdr[dim.value];
                    dimDtl[`${dim.value}Txt`] = dimHdr[`${dim.value}Txt`];
                    dimDtl[`${dim.value}Info`] = dimHdr[`${dim.value}Info`];
                }
            });
            this.updateDimDtl = !this.updateDimDtl;
        },
        calcAmount: function () {
            // this.issuedLinesObj.issueValue = this.issuedLinesObj.invUnitCost * this.issuedLinesObj.qtyIssued;
            this.issuedLinesObj.issueValue =
                parseFloat(this.issuedLinesObj.qtyIssued) *
                parseFloat(this.issuedLinesObj.invUnitCost);
        },
        calcTotalDtlIssued: function () {
            let ttlnetto = 0;
            this.issuedLines.items.forEach((trx)=> {
                if (trx.itemno) {
                    ttlnetto += trx.issueValue || 0;
                }
            });
            this.model.ttlnetto = ttlnetto;
            this.requested.items.map(item=>{
                let issuedItems = this.issuedLines.items.filter((r) => r.itemno == item.itemno);
                if((item.typeseries||'')!=''){
                    issuedItems = this.issuedLines.items.filter((r) => (r.itemno == item.itemno && r.typeseries == item.typeseries));
                }
                let totalQtyIssued = issuedItems.reduce((ttl=0,dt)=>{
                    ttl += parseFloat(dt.qtyIssued)
                    return ttl;
                },0);
                item.qtyissued = item.qtyissuedB4 + totalQtyIssued
                item.qtyOstand = item.qtyRequest - item.qtyissued
            })
        },

        close() {
            if (this.windowClose) {
                window.close();
            }

            if (
                this.$store.state.prevRoute.name
            ) {
                router.push({ name: this.$store.state.prevRoute.name });
            } else {
                router.push({ name: "logistic.home" });
            }
        },
    },
};
</script>
